// extracted by mini-css-extract-plugin
export default {"resources":"styles_resources__2-MdQ","body":"styles_body__dNcFU","warning":"styles_warning__XbPil"};